import {
  type DimensionalFramingProfileDescriptor,
  type FramingProfileDescriptor,
  FramingProfileSectionKind,
  type IJoistFramingProfileDescriptor,
  type RectangularFramingProfileDescriptor,
} from "./framingProfileDescriptorTypes";

export function isDimensionalFramingProfileDescriptor(
  descriptor: FramingProfileDescriptor,
): descriptor is DimensionalFramingProfileDescriptor {
  return descriptor.sectionKind === FramingProfileSectionKind.DIMENSIONAL;
}

export function isIJoistFramingProfileDescriptor(
  descriptor: FramingProfileDescriptor,
): descriptor is IJoistFramingProfileDescriptor {
  return descriptor.sectionKind === FramingProfileSectionKind.I_JOIST;
}

export function isRectangularFramingProfileDescriptor(
  descriptor: FramingProfileDescriptor,
): descriptor is RectangularFramingProfileDescriptor {
  return (
    descriptor.sectionKind === FramingProfileSectionKind.COMPOSITE ||
    descriptor.sectionKind === FramingProfileSectionKind.TRUSS ||
    descriptor.sectionKind === FramingProfileSectionKind.CUSTOM
  );
}
